











import { Component, Vue } from "vue-property-decorator";
import { Logger } from 'aws-amplify';

// Logger.LOG_LEVEL = "DEBUG";
const logger = new Logger("UserProfile");

@Component({
    components: {},
})
export default class UserProfile extends Vue {

}
